import REDUX_ACTION from '../../constants/action'

/**
 * Resets the domain at the given `payload.path`.
 * @param {Object} action={}
 *        {string} action.type
 *        {string} [action.payload]
 *        {string} [action.payload.path]
 *        {string} [action.payload.keysToOmit]
 */
function resetReduxAction (action) {
  return {
    type: action.type,
    reduxType: REDUX_ACTION.RESET,
    payload: action.payload || {}
  }
}

export default resetReduxAction
